import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';

/**
 * Fetches a language file from `public/i18n/`.
 *
 * Plain `HttpClient`, which means these requests pass through
 * `auth.interceptor.ts` — hence the early return there for anything that is not
 * an API URL, so a translation file never carries a bearer token.
 */
@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private readonly http = inject(HttpClient);

  getTranslation(lang: string) {
    return this.http.get<Translation>(`/i18n/${lang}.json`);
  }
}
